import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-polgend',
  templateUrl: './lieux-polgend.component.html',
  styleUrls: ['./lieux-polgend.component.css']
})
export class LieuxPolgendComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxPolgend: Subscription;
  private valeurTableauA4d_1: number[] = [];
  private valeurTableauA4d_2: number[] = [];
  private valeurTableauA4d_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxPolgend) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxPolgend', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
      for (let index = 0; index < this.lieuxPolgend.length; index++) {
        this.ajoutValidateurCroiseLieuxPolgend(index);
        this.lieuxPolgend.controls[index].updateValueAndValidity();
      }
      
      // Tri apres rechargement questionnaire
      this.trierLieuxPolgend();
    
      // Calcul des totaux lieux Polgend
      this.subLieuxPolgend = this.lieuxPolgend.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4d_1 = [];
            this.valeurTableauA4d_2 = [];
            this.valeurTableauA4d_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4d
              this.calculAutoTotauxA4d(index, this.valeurTableauA4d_1, 'aaLieuPolgendNbPerm', 'aaLieuPolgendNbPermTot');      
              this.calculAutoTotauxA4d(index, this.valeurTableauA4d_2, 'aaLieuPolgendNbPermEtp', 'aaLieuPolgendNbPermEtpTot');      
              this.calculAutoTotauxA4d(index, this.valeurTableauA4d_3, 'aaLieuPolgendNbVict', 'aaLieuPolgendNbVictTot');      
            });
          }
        });
      this.lieuxPolgend.updateValueAndValidity();
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxPolgend) {
      this.subLieuxPolgend.unsubscribe();
    }
  }

  get lieuxPolgend() {
    return this.rootForm.get('moyens').get('lieuxPolgend') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxPolgend() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuPolgendNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxPolgend.push(new UntypedFormGroup({
      aaLieuPolgendRang: new UntypedFormControl(this.lieuxPolgend.length, Validators.required),
      aaLieuPolgendCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuPolgendCodCom')),
      aaLieuPolgendQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuPolgendQp')),
      aaLieuPolgendNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuPolgendNbPerm')),
      aaLieuPolgendNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuPolgendNbPermEtp')),
      aaLieuPolgendNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuPolgendNbVict'))
    }));
    this.step = this.lieuxPolgend.length - 1 ;
    this.ajoutValidateurCroiseLieuxPolgend(this.lieuxPolgend.length - 1);
  
    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuPolgendNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxPolgend (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxPolgend.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA66Polgend,
      this.validationService.ctrlA67Polgend
    ]);
  }

  public supprimerLieuxPolgend(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxPolgend.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuPolgendCodCom']} ?`)) {
        this.lieuxPolgend.removeAt(index);
      }
    } else {
      this.lieuxPolgend.removeAt(this.lieuxPolgend.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuPolgendNb').setValue(this.lieuxPolgend.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxPolgend(): void {
    this.lieuxPolgend.controls.sort((a, b) => {
      if (a.get('aaLieuPolgendRang').value < b.get('aaLieuPolgendRang').value) {
            return -1;
      } else if (a.get('aaLieuPolgendRang').value > b.get('aaLieuPolgendRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxPolgend.length; index++) {
      this.lieuxPolgend.controls[index].get('aaLieuPolgendRang').setValue(index);
    }
    this.trierLieuxPolgend();
  }

  private calculAutoTotauxA4d(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxPolgend.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
  }

}
